import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
export const FlagImage = ({ src, alt, ...props }) => (_jsx(Flag, { src: src, alt: alt, loading: "lazy", ...props }));
const Flag = styled.img `
  width: 1em;
  height: auto;
  border-radius: 2px;
`;
